import { render, staticRenderFns } from "./HighlightsExternalLinkIcon.vue?vue&type=template&id=16d2b770&scoped=true"
import script from "./HighlightsExternalLinkIcon.vue?vue&type=script&lang=ts"
export * from "./HighlightsExternalLinkIcon.vue?vue&type=script&lang=ts"
import style0 from "./HighlightsExternalLinkIcon.vue?vue&type=style&index=0&id=16d2b770&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d2b770",
  null
  
)

export default component.exports